export enum DialogInputTags {
  deliveryDate = 'Fecha de entrega',
  deliveryHour = 'Hora de entrega'
}

export enum DialogInputLabels {
  toastWarningDateMessage = 'La fecha de entrega no puede ser menor a la actual'
}
